import { render, staticRenderFns } from "./ai-rules.vue?vue&type=template&id=0b6870a3&scoped=true&"
import script from "./ai-rules.vue?vue&type=script&lang=js&"
export * from "./ai-rules.vue?vue&type=script&lang=js&"
import style0 from "./ai-rules.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./ai-rules.vue?vue&type=style&index=1&id=0b6870a3&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6870a3",
  null
  
)

export default component.exports